import { render, staticRenderFns } from "./globaldivecenter.vue?vue&type=template&id=c1a2fed8&scoped=true&"
import script from "./globaldivecenter.vue?vue&type=script&lang=js&"
export * from "./globaldivecenter.vue?vue&type=script&lang=js&"
import style0 from "./globaldivecenter.vue?vue&type=style&index=0&id=c1a2fed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a2fed8",
  null
  
)

export default component.exports